module.exports = __webpack_public_path__ + "assets/arrow-right-652d8a8ac0295eb6dd07d6fc63a18b65.svg";